/**
 * This will make an input grow 0.75rem times the number of characters in it.
 * Also, it will select the whole contents when focused. That should probably be optional or another directive. Sorry.
 */
export function growInput() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.text = element.text();

            scope.$watch(attrs['ngModel'], function(v) {
                scope.text = v;
                if (scope.text.length) {
                    var newWidth = 0.75 * scope.text.length;
                    if (newWidth === 0) {
                        newWidth = 0.75;
                    }
                    element.css('width', newWidth + 'rem');
                }
            });

            element.bind('focus', function(evt) {
                element.select();
            });
        },
    };
}
